import Swiper from 'swiper/bundle';
// import { track } from './common/interaction';

window.Swiper = Swiper;

window.productQuantityDiscount = function (quantityFrom, quantityEnd) {
    return {
        quantityFrom,
        quantityEnd,
        highlight: false,
        initQuantityDiscount(actualQuantity) {
            this.updateQuantityHighlight(actualQuantity);
        },
        updateQuantityHighlight(actualQuantity) {
            this.highlight = false
            if (this.quantityEnd === -1) {
                if (actualQuantity >= this.quantityFrom) {
                    this.highlight = true
                }
            } else {
                if (actualQuantity >= this.quantityFrom && actualQuantity <= this.quantityEnd) {
                    this.highlight = true
                }
            }
        }
    }
}

/**
 * Il carosello della fascia "Confronta le alternative".
 *
 * Sta qui e non in alpine-common.js solo per l'override: con poche card il carousel() condiviso le
 * centrerebbe (centerInsufficientSlides), e una card sola finirebbe in mezzo alla fascia invece
 * che allineata a sinistra con le altre file della scheda. Gli altri caroselli del sito lo vogliono
 * quel comportamento, quindi non si tocca il condiviso.
 *
 * A scorrere ci pensano le frecce laterali di Swiper, gestite dal suo modulo navigation. Qui c'era
 * anche un contatore "1-5 di 8" con due bottoni in testata: i bottoni chiamavano next() e prev()
 * del condiviso, che non muovono la fila, e il contatore e' stato poi tolto perche' non serviva.
 */
window.similarProductsCarousel = function () {
    // watchSlidesProgress: swiper-slide-visible sulle card nella fila, il CSS nasconde le altre, che si
    // vedrebbero nei 12px di padding fatti per l'hover (product.css).
    const base = window.carousel({centerInsufficientSlides: false, watchSlidesProgress: true});
    const baseInit = base.init;
    return {
        ...base,
        init() {
            baseInit.call(this);
            fitCarouselCards(this.slider, compareCardSize);
            revealSlidesWhileSliding(this.slider);
            arrowsBesideTitle(this.slider, this.$el.querySelector('.compare-head .title'), this.$el);
        },
    };
}

/**
 * Solo card intere, la prima sul bordo sinistro della fila e l'ultima sul destro: la larghezza delle
 * card va nella variabile --carousel-card del contenitore (il CSS la mette sulle slide) e lo spazio
 * fra loro nello spaceBetween di Swiper. Si ricalcola a ogni resize di Swiper (beforeResize arriva
 * prima che rimisuri le slide), quindi anche quando il blocco cambia larghezza senza che cambi la
 * finestra, per esempio quando placeSimilarProducts() lo sposta.
 *
 * size(larghezzaFila, larghezzaFinestra) -> {card, gap}. La finestra decide il regime, come le media
 * query del CSS.
 */
function fitCarouselCards(swiper, size) {
    if (!swiper)
        return;

    const apply = () => {
        // Senza il padding del contenitore, come la larghezza che usa Swiper: in fondo alla scheda il
        // padding fa posto alla card ingrandita dall'hover (product.css).
        const style = getComputedStyle(swiper.el);
        const width = swiper.el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const {card, gap} = size(width, window.innerWidth);
        swiper.el.style.setProperty('--carousel-card', card + 'px');
        swiper.params.spaceBetween = gap;
    };
    apply();
    swiper.on('beforeResize', apply);
    swiper.update();
}

/**
 * Fascia "Confronta le alternative": da 1024px quante card da almeno 196 ci stanno a 12px, e la card
 * si allarga fino a riempire la riga (come bottomCardSize). Prima restava 196 e lo spazio avanzato
 * andava fra le card: fra 1024 e 1249 due card con ~140px di vuoto in mezzo (segnalato dall'utente
 * il 2026-10-08). Sotto i 1024px, due card per riga a 8px.
 *
 * Card e spazi a pixel interi: con lo spazio frazionario (25,5 a 1920) meta' delle card cominciava su
 * mezzo pixel e i bordi da 1px (tasto "Scegli questo", immagini) si disegnavano sfumati su due pixel,
 * un filetto scuro diverso da card a card. I pochi pixel che avanzano restano in fondo a destra.
 */
function compareCardSize(width, viewport) {
    if (viewport < 1024) {
        const card = Math.floor((width - 8) / 2);
        return {card, gap: width - 2 * card};
    }

    const gap = 12;
    const count = Math.max(1, Math.floor((width + gap) / (196 + gap)));
    return {card: Math.floor((width - (count - 1) * gap) / count), gap};
}

/**
 * Le card fuori dalla fila si nascondono (product.css) solo a carosello fermo. Swiper sposta
 * swiper-slide-visible appena parte lo scorrimento, sulla posizione d'arrivo: col visibility legato
 * solo a quella classe le card che uscivano sparivano di colpo e le nuove comparivano gia' ferme,
 * invece di scorrere (segnalato dall'utente il 2026-10-12). is-sliding sul contenitore dal primo
 * trascinamento o dall'inizio della transizione fino alla sua fine.
 */
function revealSlidesWhileSliding(swiper) {
    if (!swiper)
        return;

    const start = () => swiper.el.classList.add('is-sliding');
    const end = () => swiper.el.classList.remove('is-sliding');
    swiper.on('sliderFirstMove', start);
    swiper.on('transitionStart', start);
    swiper.on('transitionEnd', end);
}

/**
 * Le frecce a meta' altezza delle card e non dello swiper: nei caroselli in fondo il titolo sta dentro
 * lo swiper, sopra la fila, ed e' alto diverso secondo la larghezza. Il centro della fila va in
 * --carousel-arrow-top (product.css), ricalcolato dopo ogni resize di Swiper.
 */
function centerArrowsOnCards(swiper) {
    if (!swiper)
        return;

    const apply = () => {
        const row = swiper.wrapperEl;
        swiper.el.style.setProperty('--carousel-arrow-top', (row.offsetTop + row.offsetHeight / 2) + 'px');
    };
    apply();
    swiper.on('resize', apply);
}

/**
 * Sotto i 1024px le frecce dei caroselli (fascia confronto, Best seller, Visti di recente) sono quelle
 * di "Acquistati insieme": 44px, sulla riga del titolo, a destra (product.css). La riga e' alta quanto
 * il piu' alto fra frecce e titolo, con l'altro centrato: il CSS lo calcola dall'altezza del titolo,
 * che va in --carousel-title-height su host (l'antenato comune di titolo e frecce). Il titolo va a capo
 * secondo la larghezza, quindi si rimisura dopo ogni resize di Swiper e quando arriva il webfont.
 */
function arrowsBesideTitle(swiper, title, host) {
    if (!swiper || !title || !host)
        return;

    const apply = () => host.style.setProperty('--carousel-title-height', title.offsetHeight + 'px');
    apply();
    swiper.on('resize', apply);
    if (document.fonts)
        document.fonts.ready.then(apply);
}

/**
 * Caroselli in fondo alla scheda (#offerte): sotto i 1024px card fisse da 200 (218 da 640) a 8px, la
 * fila esce dal bordo destro; da 1024 quante card da almeno 200 (230 da 1500) ci stanno a 12px, e la
 * card si allarga fino a riempire la riga. Sotto i 640 il minimo e' il confezionamento su una riga:
 * "(2,89 € a risma in conf. da 5)" e' 179px a 12px, e la card ne lascia 182 (200 meno bordo e padding).
 */
function bottomCardSize(width, viewport) {
    if (viewport < 640)
        return {card: 200, gap: 8};
    if (viewport < 1024)
        return {card: 218, gap: 8};

    const gap = 12;
    const min = viewport >= 1500 ? 230 : 200;
    const count = Math.max(1, Math.floor((width + gap) / (min + gap)));
    return {card: Math.floor((width - (count - 1) * gap) / count), gap};
}

/**
 * Le card delle liste prodotto in fondo alla scheda (Best seller e Visti di recente, dal 2026-10-09):
 * sotto i 1024px 229 come nel carosello dei piu' venduti della sottocategoria (.prod-slider), da 1024
 * quante card da almeno 275 ci stanno a 12px. Il minimo lo da' la riga in alto: "Consegna in 12 giorni"
 * (150) + codice e cuoricino (105) + padding 16 e bordi 2 = 273; sotto, la chip della disponibilita'
 * va a capo e si allunga (era 230 fino al 2026-10-12: 6 card a 1920, 4 da 263 a 1440, tutte a capo).
 */
function listCardSize(width, viewport) {
    if (viewport < 1024)
        return {card: 229, gap: 8};

    const gap = 12;
    const count = Math.max(1, Math.floor((width + gap) / (275 + gap)));
    return {card: Math.floor((width - (count - 1) * gap) / count), gap};
}

/**
 * Il menu a tendina che prende il posto delle pillole variante quando i valori sono troppi
 * (product-variants.hbs). Le voci sono link stampati dal server: la ricerca non le ricostruisce,
 * le nasconde e basta, confrontando il testo senza maiuscole e accenti.
 */
window.variantDropdown = function () {
    return {
        open: false,
        query: "",
        noResults: false,
        animation: {
            ['x-transition:enter']: 'transition ease-in duration-50',
            ['x-transition:enter-start']: 'opacity-0 transform scale-y-90',
            ['x-transition:enter-end']: 'opacity-100 transform scale-y-100',
            ['x-transition:leave']: 'transition ease-in duration-100',
            ['x-transition:leave-start']: 'opacity-100 transform scale-y-100',
            ['x-transition:leave-end']: 'opacity-0 transform scale-y-90',
        },
        toggle($nextTick) {
            this.open = !this.open;
            if (this.open)
                $nextTick(() => this.$refs.searchInput.focus());
        },
        close() {
            this.open = false;
        },
        normalize(text) {
            return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        },
        filter() {
            const query = this.normalize(this.query);
            let visible = 0;
            this.$refs.options.querySelectorAll('.variant-option').forEach(option => {
                const match = this.normalize(option.dataset.value).includes(query);
                // Non la classe hidden di Tailwind: il flex di .variant-option ha piu' specificita'.
                option.style.display = match ? '' : 'none';
                if (match)
                    visible++;
            });
            this.noResults = visible === 0;
        }
    };
}

/**
 * Il modulo "Acquistati insieme" nel box carrello (component/bought-together.hbs).
 *
 * Le righe sono tutte nel DOM e la lista scorre da sola (overflow): qui niente chiamate al server e
 * niente paginazione. Il componente fa tre cose:
 * - accende la sfumatura in fondo alla lista finche' la lista non e' in fondo (atEnd);
 * - carica le immagini delle righe oltre la quarta (data-src) quando si avvicinano scorrendo: un
 *   IntersectionObserver con radice l'area che scorre e un margine di circa una riga e mezza, perche'
 *   il loading="lazy" del browser misura sulla finestra e dentro un'area che scorre le caricherebbe
 *   tutte appena il modulo e' in vista;
 * - tiene la barra della spedizione gratuita, che vale il carrello senza IVA, solo quello, e si
 *   ricalcola a ogni cart-update, cosi' segue anche le aggiunte fatte dal tasto grande della scheda.
 *
 * Sotto i 1024px (lo smBreakpoint di productDetail) la lista non scorre: va a pagine da 3 righe, con
 * frecce e contatore in testata e lo swipe orizzontale. Le righe fuori pagina prendono l'attributo
 * hidden, cosi' il markup resta uno solo per tutte e due le forme. Le immagini delle pagine dopo la
 * prima le carica lo stesso IntersectionObserver quando la pagina compare.
 */
window.boughtTogether = function ({threshold, cartTotal}) {
    const LOOK_AHEAD = '0px 0px 150px 0px';
    const PAGE_SIZE = 3;
    const PAGED_QUERY = '(max-width: 1023px)';

    return {
        percent: 0,
        reached: false,
        missing: '',
        atEnd: false,
        paged: false,
        page: 0,
        pageCount: 1,
        touchX: null,
        touchY: null,
        init() {
            this.setValue(cartTotal);
            this.rows = Array.from(this.$refs.list.children);
            this.pageCount = Math.ceil(this.rows.length / PAGE_SIZE);

            const query = window.matchMedia(PAGED_QUERY);
            this.setPaged(query.matches);
            const onChange = e => this.setPaged(e.matches);
            if (query.addEventListener)
                query.addEventListener('change', onChange);
            else
                query.addListener(onChange);

            // Le altezze delle righe cambiano con la larghezza (il prezzo va a capo) e col webfont:
            // a pagine vanno rimisurate. Solo se cambia la larghezza: a mobile la finestra cambia
            // altezza a ogni scroll, quando la barra del browser entra ed esce.
            let lastWidth = window.innerWidth;
            window.addEventListener('resize', () => {
                if (window.innerWidth === lastWidth)
                    return;
                lastWidth = window.innerWidth;
                if (this.paged)
                    this.equalizeRows();
            });
            if (document.fonts && document.fonts.ready)
                document.fonts.ready.then(() => this.paged && this.equalizeRows());

            this.updateAtEnd();
            this.lazyImages();
        },
        setPaged(paged) {
            this.paged = paged;
            this.equalizeRows();
            if (!paged)
                this.$nextTick(() => this.updateAtEnd());
        },
        /**
         * A pagine tutte le righe alte quanto la piu' alta (nome su due righe e prezzo andato a capo
         * anche su tre, a 320px) e la lista alta quanto una pagina piena: sfogliando il modulo non
         * cambia mai altezza e quello che sta sotto non salta, anche sull'ultima pagina, che ha spesso
         * meno righe. Si misura con tutte le righe visibili e senza altezze imposte. Fuori dalle
         * pagine toglie tutto e rimette visibili tutte le righe.
         */
        equalizeRows() {
            const list = this.$refs.list;
            list.style.minHeight = '';
            this.rows.forEach(row => {
                row.hidden = false;
                row.style.minHeight = '';
            });
            if (!this.paged)
                return;

            const tallest = Math.max(...this.rows.map(row => row.offsetHeight));
            this.rows.forEach(row => row.style.minHeight = tallest + 'px');
            if (this.pageCount > 1)
                list.style.minHeight = (tallest * PAGE_SIZE) + 'px';
            this.showPage(Math.min(this.page, this.pageCount - 1));
        },
        showPage(index) {
            this.page = index;
            this.rows.forEach((row, i) => row.hidden = Math.floor(i / PAGE_SIZE) !== index);
        },
        go(delta) {
            const target = this.page + delta;
            if (!this.paged || target < 0 || target >= this.pageCount)
                return;

            this.showPage(target);
            // Le frecce non si tracciano (decisione dell'utente del 2026-10-12): l'evento non e' nel registro.
            // track('bought_together_click_page', {target: delta > 0 ? 'next' : 'prev', position: target + 1});
        },
        touchStart(e) {
            const touch = e.touches[0];
            this.touchX = touch.clientX;
            this.touchY = touch.clientY;
        },
        touchEnd(e) {
            if (!this.paged || this.touchX === null)
                return;

            const touch = e.changedTouches[0];
            const dx = touch.clientX - this.touchX;
            const dy = touch.clientY - this.touchY;
            this.touchX = null;
            // Solo un gesto orizzontale deciso: uno scroll verticale che sbanda non cambia pagina.
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy))
                this.go(dx < 0 ? 1 : -1);
        },
        setValue(value) {
            this.reached = value >= threshold;
            this.percent = Math.min(100, Math.round(value / threshold * 100));
            this.missing = utils.formatPrice(Math.max(0, threshold - value));
        },
        updateFromCart({cart}) {
            this.setValue(cart.empty ? 0 : cart.total.productsWoVat);
        },
        /** In fondo con 1px di tolleranza: con lo zoom scrollTop puo' essere frazionario. */
        updateAtEnd() {
            const scroll = this.$refs.scroll;
            this.atEnd = scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 1;
        },
        lazyImages() {
            const pending = this.$refs.scroll.querySelectorAll('img[data-src]');
            if (!pending.length)
                return;

            const load = img => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            };
            if (!window.IntersectionObserver) {
                pending.forEach(load);
                return;
            }

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting)
                        return;
                    observer.unobserve(entry.target);
                    load(entry.target);
                });
            }, {root: this.$refs.scroll, rootMargin: LOOK_AHEAD});
            pending.forEach(img => observer.observe(img));
        },
    };
}

/**
 * Il "+" di una riga di "Acquistati insieme": e' il tasto di aggiunta rapida (quickAddToCart in
 * alpine-common.js, stessa API e stesse conferme del tasto grande) con in piu' la spunta verde per
 * 2 secondi dopo un'aggiunta andata a buon fine. Se il server dice di no ci pensa CartApi a mostrare
 * l'errore, come per il tasto grande, e la spunta non compare. La riga resta: il prodotto si puo'
 * aggiungere di nuovo.
 */
window.boughtTogetherAdd = function (config) {
    const base = window.quickAddToCart(config);
    const baseSyncFromCart = base.syncFromCart;
    return {
        ...base,
        added: false,
        syncFromCart(detail) {
            // La spunta prima del sync di base, che manda l'evento GTM: se quello lancia, il
            // cliente la spunta la vede comunque.
            if (this.waitingOwnResponse && detail.eventProduct === config.productCode) {
                this.added = true;
                clearTimeout(this.addedTimeout);
                this.addedTimeout = setTimeout(() => this.added = false, 2000);
            }
            baseSyncFromCart.call(this, detail);
        },
    };
}

window.imageGallery = function (isFav) {
    const images = Array.from(document.querySelectorAll(".product-gallery.prod-gallery-item"));
    const isImg = images.map(() => false);
    isImg[0] = true;
    return {
        isFav,
        imageModalOpen: false,
        isImg: Object.assign({}, isImg),
        activeImg: 0,
        productImageSlider: null,
        modalActiveImg: 0,
        modalIsImg: Object.assign({}, isImg),
        productImageModalSlider: null,
        openModal() {
            this.imageModalOpen = true;
        },
        closeImageModal() {
            this.imageModalOpen = false;
        },
        zoom(e) {
            const zoomer = e.currentTarget;
            let offsetX
            let offsetY;
            e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
            e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
            const x = offsetX / zoomer.offsetWidth * 100
            console.log(offsetX, offsetY, x, offsetY / zoomer.offsetHeight * 100
            )
            const y = offsetY / zoomer.offsetHeight * 100
            zoomer.style.backgroundPosition = x + '% ' + y + '%';
        },
        setImgOutside(index) {
            this.productImageSlider.slideTo(index);
        },
        setProductImg(index) {
            this.productImageSlider.slideTo(index);
            this.isImg[this.activeImg] = false;
            this.activeImg = index;
            this.isImg[index] = true;
        },
        setModalGalleryImg(index) {
            this.productImageModalSlider.slideTo(index);
            this.modalIsImg[this.modalActiveImg] = false;
            this.modalActiveImg = index;
            this.modalIsImg[index] = true;
        },
        initGallery() {
            let options = {
                slidesPerView: 1,
                navigation: false,
            }

            this.productImageSlider = new Swiper(this.$refs.fullGallery, options);
            this.productImageSlider.on('slideChange', i => this.setProductImg(i.activeIndex));

            options = {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            }

            this.productImageModalSlider = new Swiper(this.$refs.productImageModal, options);
            this.productImageModalSlider.on('slideChange', i => this.setModalGalleryImg(i.activeIndex));
        },
    }
}

window.productDetail = function (productCode, packageSize, isFav, finalPrice, categoriaRaccoglitore) {
    return {
        productCode,
        isFav,
        packageSize,
        showScaglioniTp: false,
        smBreakpoint: 1024,
        lgBreakpoint: 1500,
        // ---- CUSTOM PER MODALE RACCOGLITORI
        categoriaRaccoglitore,
        // ---- CUSTOM PER MODALE RACCOGLITORI
        ...window.productCommon(),
        // ---------------------
        initProductDetail(cartQuantity, cartConfig, $watch) {
            console.log("init detail")
            if (cartQuantity > 0) {
                this.$refs.inputCartQuantity.style.color = "#ce3575";
            }

            // Replace history instead of pushing when clicking variant links
            // This prevents multiple back button presses after exploring variants
            document.querySelectorAll('.variant-pill, .variant-option').forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.location.replace(this.href);
                });
            });

            this.cartQuantity = cartQuantity;
            this.buyMultiplier = cartConfig.buyMultiplier || 1;
            this.cartUpdateQuantity = cartQuantity > 0 ? cartQuantity : (cartConfig.buyMultiplier > 1 ? cartConfig.buyMultiplier : 1);
            this.cartConfig = cartConfig;
            this.selectorWheel = cartConfig.selectorWheel;

            const h1 = document.querySelector("div.prod-detail h1").innerHTML;
            const brand = document.querySelector("div.prod-detail img.brand-image").alt;
            const category = document.querySelector(".breadcrumb .breadcrumb-link:nth-last-child(2) a p").innerHTML;
            gtmUtils.currentProduct = {name: h1, id: productCode, price: finalPrice, brand, category};
            gtmUtils.productImpression(gtmUtils.currentProduct);
            const self = this;
            $watch('cartUpdateQuantity', value => {
                // console.log('EVENT cartUpdateQuantity', this.cartUpdateQuantity, value);
                if (utils.isArray(value))
                    value = value[0];

                if (parseInt(value) === -100 && self.$refs.inputCartQuantity.dataset.palletUrl) {
                    document.location = self.$refs.inputCartQuantity.dataset.palletUrl;
                    return;
                }

                if (!/^\d+$/.test(value))
                    return;

                value = parseInt(value);
                if (value % self.buyMultiplier !== 0)
                    value = Math.ceil(value / self.buyMultiplier) * self.buyMultiplier;

                if (this.cartUpdateQuantity !== value) {
                    this.cartUpdateQuantity = value;
                    // $watch event is going to be fired again
                }
            });
            this.resize();
            // La descrizione cresce dopo il primo layout, quando arriva il webfont o le immagini
            // che a volte contiene: senza rimisurare il carosello resterebbe dove stava.
            if (document.querySelector('.similar-products') !== null && window.ResizeObserver)
                new ResizeObserver(() => this.pushSimilarProductsBelowDescription())
                    .observe(this.$refs.productDescription);
            // Col webfont le righe cambiano larghezza: il taglio a 7 righe va rimisurato dopo,
            // e con lui il posto del carosello.
            if (document.fonts && document.fonts.ready)
                document.fonts.ready.then(() => {
                    this.measureDescription();
                    this.pushSimilarProductsBelowDescription();
                    this.fitLeftColWide();
                });
            // Fascia Feedaty e specifiche si allargano solo se a destra non c'e' niente alla loro
            // altezza: va rimisurato quando cambia una delle cose che decidono dove finisce la destra
            // (descrizione, box carrello) o dove comincia il blocco (galleria, fascia confronto).
            // Non si osserva il blocco stesso, che allargandosi cambia altezza.
            if (window.ResizeObserver) {
                const observer = new ResizeObserver(() => this.fitLeftColWide());
                [this.$refs.productDescription, document.querySelector('.product-container'),
                    document.querySelector('.images-container'), document.querySelector('.similar-products')]
                    .filter(el => el)
                    .forEach(el => observer.observe(el));
            }

            if (this.selectorWheel)
                this.initSelectorWheel();

            // I caroselli in fondo usano il carousel() condiviso con la home: le card intere si
            // aggiungono da qui. Alpine inizializza i componenti annidati dopo questo, quindi al giro
            // dopo, quando Swiper c'e' gia'. Qui la fila parte da sinistra anche con poche card.
            setTimeout(() => document.querySelectorAll('#offerte .swiper-container').forEach(el => {
                if (!el.swiper)
                    return;
                el.swiper.params.centerInsufficientSlides = false;
                // swiper-slide-visible sulle card nella fila: il CSS nasconde le altre, che si vedrebbero
                // nel padding fatto per l'hover (product.css).
                el.swiper.params.watchSlidesProgress = true;
                fitCarouselCards(el.swiper, el.querySelector('.product-item') ? listCardSize : bottomCardSize);
                centerArrowsOnCards(el.swiper);
                revealSlidesWhileSliding(el.swiper);
                arrowsBesideTitle(el.swiper, el.querySelector(':scope > .title'), el);
            }));
        },

        // ---------------------
        cartConfig: {deniedByModal: null, modalChain: [], modalData: {}},
        cartQuantity: 0,
        buyMultiplier: 1,
        cartUpdateQuantity: 0,
        addToCart($dispatch) {
            if (this.cartConfig.deniedByModal) {
                return window.modal.openModal($dispatch, this.cartConfig.deniedByModal, {
                    ...this.cartConfig.modalData, productCode
                });
            }

            if (this.cartQuantity > 0 && this.cartUpdateQuantity <= 0) {
                modal.openDefinedModal($dispatch, 'cart-confirm-remove').then(detail => {
                    if (detail.action === true)
                        CartApi.removeProductFromCart(productCode, $dispatch);
                });
            } else {
                if (this.cartUpdateQuantity <= 0)
                    this.cartUpdateQuantity = 1;
                if (this.cartUpdateQuantity === this.cartQuantity && !this.cartConfig.buyQuantitySelectable)
                    this.cartUpdateQuantity++;
                this.cartChain($dispatch);
            }
            $dispatch('update-quantityhighlight-view', this.cartUpdateQuantity);
        },
        async cartChain($dispatch) {
            const modalChain = this.cartConfig.modalChain.slice();
            console.log(this.categoriaRaccoglitore, this.packageSize, this.cartUpdateQuantity, this.cartQuantity);
            if (this.categoriaRaccoglitore && this.packageSize > 1 && this.cartUpdateQuantity > 1) {
                modalChain.unshift('raccoglitore-confezione-maggiore-uno');
                this.cartConfig.modalData.packageSize = this.packageSize;
                this.cartConfig.modalData.cartUpdateQuantity = this.cartUpdateQuantity;
                this.cartConfig.modalData.totalQuantity = this.packageSize * this.cartUpdateQuantity;
            }
            while (modalChain.length > 0) {
                const nextModal = modalChain.shift();
                const res = await modal.openDefinedModal($dispatch, nextModal, this.cartConfig.modalData);
                if (res.action !== true)
                    return;
            }
            CartApi.updateProductIntoCart(productCode, this.cartUpdateQuantity / this.buyMultiplier, $dispatch);
        },

        updateDetailCartData({eventProduct, actualQuantity, quantityVariation}) {
            // Da questa pagina ora si aggiunge al carrello anche un altro prodotto, col tasto rapido
            // sulle card dei simili. Senza questo controllo la quantita' del prodotto aperto veniva
            // sovrascritta con quella del prodotto della card, e partiva un evento GTM sbagliato.
            if (eventProduct !== productCode)
                return;

            gtmUtils.cartProductEvent(gtmUtils.currentProduct, quantityVariation);

            this.cartQuantity = actualQuantity * this.buyMultiplier;
            this.cartUpdateQuantity = actualQuantity * this.buyMultiplier;

            this.$refs.inputCartQuantity.style.color = actualQuantity > 0 ? "#ce3575" : "#2a455c";
        },

        // ---------------------
        selectorWheel: false,
        $wheel: null, $fakeKey: null,
        $options: [],
        wheelScrollData: {selectedIndex: -1, optionHeight: 20, paddingOffset: 14, targetScroll: 0},
        initSelectorWheel() {
            this.$wheel = this.$refs.wheel;
            this.$fakeKey = this.$refs.inputCartQuantity; // si chiama uguale solo per compatibilità
            this.$options = [this.$refs.qty0, ...this.cartConfig.buyQuantityOptions.map((x, i) => this.$refs['qty' + x])];
            this.optionClick(this.cartUpdateQuantity);

            const self = this;
            utils.scroll.intercept(this.$wheel, (e) => {
                if (e.isScrollDown !== undefined)
                    self.scrollOptBy(e.isScrollDown ? 1 : -1);
                else if (e.dragStart) {
                    self.wheelScrollData.scrollStartIndex = self.wheelScrollData.selectedIndex;
                } else if (e.dragY !== undefined && Math.abs(e.dragY) > this.wheelScrollData.optionHeight) {
                    const scrollCount = Math.round(e.dragY / this.wheelScrollData.optionHeight);
                    self.scrollToIndex(self.wheelScrollData.scrollStartIndex + scrollCount);
                }
            });
            this.$fakeKey.addEventListener('keydown', utils.scroll.interceptEventForScrollKeys(e => {
                self.scrollOptBy(e.isScrollDown ? 1 : -1);
            }));
        },
        scrollOptBy(delta) {
            this.scrollToIndex(this.wheelScrollData.selectedIndex + delta);
        },
        scrollToIndex(index) {
            this.$fakeKey.focus();
            index = Math.max(0, Math.min(this.$options.length - 1, index));

            const value = parseInt(this.$options[index].dataset.value);
            if (this.cartUpdateQuantity !== value) {
                // console.log(`UPDATE selectedIndex ${index} to value ${value}`);
                this.cartUpdateQuantity = value;
            }

            if (this.wheelScrollData.selectedIndex !== index) {
                this.wheelScrollData.selectedIndex = index;
                this.highlightQuantity(value);
            }

            const targetScroll = this.wheelOptionIndexToScroll(index);
            if (Math.abs(this.wheelScrollData.targetScroll - targetScroll) > 1) {
                this.wheelScrollData.targetScroll = targetScroll;
                // console.log(`UPDATE selectedIndex ${index} to targetScroll ${targetScroll}`);
                this.$refs.items.style.top = (-targetScroll) + "px";
            }
        },
        highlightQuantity(selectedValue) {
            this.$options.forEach($option => utils.removeClass($option, 'selected') || utils.addClass($option, 'unselected'));
            const $selectedOption = this.$refs['qty' + selectedValue];
            utils.removeClass($selectedOption, 'unselected');
            utils.addClass($selectedOption, 'selected');
        },
        optionClick(qty, $event) {
            $event && $event.preventDefault();
            this.scrollToIndex(this.wheelValueToIndex(qty));
            utils.resetTextSelection();
        },
        wheelOptionIndexToScroll(index) {
            (index !== undefined) || (index = this.wheelScrollData.selectedIndex);
            let scrollTo = index * this.wheelScrollData.optionHeight - this.wheelScrollData.paddingOffset;
            return Math.max(-this.wheelScrollData.paddingOffset, scrollTo);
        },
        wheelValueToIndex(value) {
            for (let i = 0; i < this.$options.length; i++) {
                const $option = this.$options[i];
                if (parseInt($option.dataset.value) === parseInt(value))
                    return i;
            }
            return -1;
        },

        // ---------------------
        goToPallet(url) {
            document.location = url;
        },
        // ---------------------
        // La descrizione tagliata a 7 righe: descriptionClamped e' lo stato del taglio,
        // descriptionOverflows dice se il testo sborda e quindi se link e sfumatura hanno senso,
        // infoButtonInDescription se resize() ha portato il tasto "Info prodotto" nella riga sotto
        // il testo (da lg in su), che allora si vede anche senza link.
        descriptionClamped: true,
        descriptionOverflows: false,
        infoButtonInDescription: false,
        /**
         * Se il testo tagliato a 7 righe ne nasconde altre. Si misura col taglio applicato: quando
         * la descrizione e' aperta si rimette la classe per il tempo della misura.
         */
        measureDescription() {
            const text = this.$refs.shortText;
            if (!text)
                return;

            const expanded = !this.descriptionClamped;
            if (expanded)
                text.classList.add('short-text--clamped');
            this.descriptionOverflows = text.scrollHeight > text.clientHeight;
            if (expanded)
                text.classList.remove('short-text--clamped');
        },
        toggleDescription() {
            this.descriptionClamped = !this.descriptionClamped;
            // Il carosello segue la colonna centrale: aperta o chiusa la descrizione, si rimisura.
            this.$nextTick(() => {
                this.pushSimilarProductsBelowDescription();
                this.fitLeftColWide();
            });
        },
        /**
         * Le specifiche sono stampate due volte: sotto la fascia confronto da sm in su, in fondo alla
         * pagina sotto sm. Si va a quella che si vede, senza legarsi alle larghezze: la scelta per
         * breakpoint mandava da lg alle specifiche in fondo, nascoste da quando stanno sotto la
         * fascia confronto anche li', e il tasto non faceva niente.
         */
        infoProductButtonClicked() {
            const specs = Array.from(document.querySelectorAll('.product-specs')).find(el => el.offsetParent !== null);
            if (specs)
                specs.scrollIntoView({behavior: "smooth"});
        },
        /**
         * I prodotti simili stanno sempre <b>prima</b> delle specifiche, ma le specifiche cambiano
         * posto nel DOM: a 2 e 3 colonne sono in .left-col, a mobile nel contenitore in fondo.
         * Quindi due agganci, e il blocco e' uno solo che viene spostato, come gia' si fa per la
         * fascia feedaty: duplicare il markup vorrebbe dire due volte i link prodotto e due
         * istanze Swiper.
         */
        placeSimilarProducts() {
            const block = document.querySelector('.similar-products');
            if (block === null)
                return;

            const target = window.innerWidth >= this.smBreakpoint
                ? this.$refs.similarProductsCol
                : this.$refs.similarProductsSm;

            if (block.parentElement !== target)
                target.appendChild(block);
        },
        /**
         * Da lg il carosello sborda a destra sull'area della colonna centrale, che li' e' vuota
         * perche' il box carrello e' assoluto. Se pero' la descrizione e' lunga arriva fin sotto e
         * le card le finiscono sopra. In CSS non si puo' far dipendere la posizione di un blocco
         * dall'altezza della colonna accanto, quindi si misura e si spinge giu' il carosello fino a
         * sotto la descrizione.
         */
        pushSimilarProductsBelowDescription() {
            // Senza fascia confronto il primo blocco largo e' quello di Feedaty e specifiche, che
            // altrimenti finirebbe lui sotto la descrizione.
            const block = document.querySelector('.similar-products') || this.$refs.leftColWide;
            if (!block)
                return;

            block.style.marginTop = '';

            // Sotto lg il carosello e' largo quanto la sua colonna e la descrizione non la incrocia.
            if (window.innerWidth < this.lgBreakpoint)
                return;

            // Il margine del CSS vale anche come stacco da tenere sotto la descrizione.
            const gap = parseFloat(window.getComputedStyle(block).marginTop) || 0;
            const descriptionBottom = this.$refs.productDescription.getBoundingClientRect().bottom;
            const push = descriptionBottom + gap - block.getBoundingClientRect().top;

            if (push > 0)
                block.style.marginTop = (gap + push) + 'px';
        },
        /**
         * Fascia Feedaty e specifiche (left-col-wide): se a destra del blocco c'e' spazio vuoto, il
         * blocco lo riempie fino al bordo della scheda. Spazio vuoto vuol dire che colonna centrale e
         * box carrello finiscono sopra il blocco, senza altri stacchi da rispettare (fino al
         * 2026-10-07 si chiedeva in piu' lo stacco fra i blocchi, e blocchi con il vuoto a destra
         * restavano stretti). Altrimenti restano larghi quanto la colonna sinistra, da lg quanto la
         * fascia confronto. Si decide blocco per blocco: le specifiche cominciano piu' in basso e
         * possono trovare spazio anche quando la fascia Feedaty non lo trova.
         *
         * Da chiamare dopo pushSimilarProductsBelowDescription(), che puo' spostare il blocco in giu'.
         */
        fitLeftColWide() {
            const wide = this.$refs.leftColWide;
            if (!wide)
                return;

            const blocks = Array.from(wide.children);
            blocks.forEach(block => block.style.width = '');

            // Sotto sm dentro non si vede niente: fascia nascosta, specifiche in fondo alla pagina.
            if (window.innerWidth < this.smBreakpoint)
                return;

            // La colonna centrale e' alta quanto la riga (flex), quindi il fondo si prende dai suoi
            // figli; il box carrello da lg e' assoluto e si conta a parte. Il bordo destro e' quello
            // della colonna o del box, il piu' a destra dei due. Coordinate della finestra: a pagina
            // scrollata sono negative, quindi il fondo parte da -Infinity e non da 0.
            const central = document.querySelector('.central-col');
            const box = document.querySelector('.product-container');
            let rightBottom = -Infinity;
            let rightEdge = central.getBoundingClientRect().right;
            [...central.children, box].forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.height === 0)
                    return;
                rightBottom = Math.max(rightBottom, rect.bottom);
                rightEdge = Math.max(rightEdge, rect.right);
            });

            blocks.forEach(block => {
                const rect = block.getBoundingClientRect();
                if (rect.height > 0 && rect.top >= rightBottom)
                    block.style.width = (rightEdge - rect.left) + 'px';
            });
        },
        /**
         * "Acquistati insieme" sta sopra le CTA del box carrello. Sotto i 1024px va in fondo, subito
         * dopo le alternative: l'ordine a mobile e' carrello, varianti, descrizione, alternative,
         * acquistati insieme. Il blocco e' uno solo e si sposta, come i prodotti simili: stamparlo due
         * volte darebbe due volte i link e il tracking. Il posto di partenza si ricorda al primo giro
         * (il nodo che lo segue, null se e' l'ultimo del box).
         */
        placeBoughtTogether() {
            const block = document.querySelector('.bought-together');
            if (block === null)
                return;

            if (this.boughtTogetherHome === undefined) {
                this.boughtTogetherContainer = block.parentElement;
                this.boughtTogetherHome = block.nextElementSibling;
            }

            if (window.innerWidth < this.smBreakpoint) {
                if (block.parentElement !== this.$refs.boughtTogetherSm)
                    this.$refs.boughtTogetherSm.appendChild(block);
            } else if (block.parentElement !== this.boughtTogetherContainer || block.nextElementSibling !== this.boughtTogetherHome) {
                this.boughtTogetherContainer.insertBefore(block, this.boughtTogetherHome);
            }
        },
        resize() {
            this.placeSimilarProducts();
            this.placeBoughtTogether();

            if (window.innerWidth >= this.lgBreakpoint) {
                // La fascia feedaty non va piu' in fondo alla pagina: resta sotto la fascia confronto (left-col-wide).
                // this.$refs.feedatyContainerLg.appendChild(document.querySelector('.feedaty-main'))

                if (document.querySelector('.availability-pieces') !== null) {
                    this.$refs.availabilityLg.appendChild(document.querySelector('.availability-pieces'))
                    this.$refs.availabilityLg.style.display = "block";
                }

                // Il tasto va nella riga sotto la descrizione, accanto a "Mostra altro…".
                if (document.querySelector('.product-info-button') !== null) {
                    this.$refs.descriptionActions.appendChild(document.querySelector('.product-info-button'));
                    this.infoButtonInDescription = true;
                }

                if (document.querySelector('.availability-delay-days') !== null) {
                    this.$refs.availabilityLg.appendChild(document.querySelector('.availability-delay-days'));
                    this.$refs.availabilityLg.style.display = "block";
                }

                if (document.querySelector('.availability-deferred') !== null) {
                    this.$refs.availabilityLg.appendChild(document.querySelector('.availability-deferred'));
                    this.$refs.availabilityLg.style.display = "block";
                }

                // Il box carrello e' assoluto e la colonna centrale deve essere almeno alta quanto
                // lui: min-height e non height, perche' con l'altezza fissa la descrizione aperta
                // da "Mostra altro…" sborda dalla colonna e finisce sotto il blocco in fondo.
                document.querySelector('.central-col').style.height = '';
                document.querySelector('.central-col').style.minHeight = document.querySelector('.product-container').offsetHeight + 'px';
            } else {
                document.querySelector('.central-col').style.height = '';
                document.querySelector('.central-col').style.minHeight = '';
                // Non si sposta piu', vedi sopra.
                // this.$refs.feedatyContainerSmall.appendChild(document.querySelector('.feedaty-main'))

                if (document.querySelector('.availability-pieces') !== null) {
                    this.$refs.availabilityLg.style.display = "none";
                    this.$refs.availabilityPieces.appendChild(document.querySelector('.availability-pieces'));
                }

                if (document.querySelector('.availability-delay-days') !== null) {
                    this.$refs.availabilityDelayDays.appendChild(document.querySelector('.availability-delay-days'));
                }

                if (document.querySelector('.availability-deferred') !== null) {
                    this.$refs.availabilityDeferred.appendChild(document.querySelector('.availability-deferred'));
                }

                if (document.querySelector('.product-info-button') !== null) {
                    this.$refs.rightInfoCol.appendChild(document.querySelector('.product-info-button'));
                    this.infoButtonInDescription = false;
                }
            }

            // Per ultimo: il tasto "Info prodotto" entra ed esce dalla descrizione qui sopra e ne
            // cambia l'altezza, e il taglio a 7 righe cambia con la larghezza della colonna.
            this.measureDescription();
            this.pushSimilarProductsBelowDescription();
            this.fitLeftColWide();
        },
    };
}
